import {
  constructList,
  getFacet,
  getText,
  sortAndSliceList,
  appendGOATandCountryCodeToTitle,
  stripSpecialCharacterFromString,
} from 'shared/utils/pageMetadataUtils';
import { t } from 'localization/utils/t';
import { startCase } from './startCase';

const TP = 'shared.utils.getUpperMaterialValueMetadata';

export const getUpperMaterialValueMetadata = ({
  pageTitle,
  pageDescription,
  constructorResponse,
  locale,
  query,
}) => {
  const { groups = [], facets = [] } = constructorResponse?.response || {};
  const upperMaterialValue: string = query?.upperMaterialValue;
  const upperMaterialValueWithStartCase: string = startCase(upperMaterialValue);
  const topLevelCategory: string =
    groups?.[0]?.group_id === 'sneakers'
      ? t(`${TP}.shoes`, 'shoes')
      : stripSpecialCharacterFromString(groups?.[0]?.group_id);
  const topLevelCategoryWithStartCase: string = startCase(topLevelCategory);

  const brandFacet = getFacet(facets, 'brand');
  const topThreeBrands = constructList({
    list: sortAndSliceList(brandFacet?.options),
    key: 'display_name',
  });

  // Pulling out static strings for translation purposes
  const more = t(`${TP}.more`, 'More');

  const _topThreeBrands = topThreeBrands?.constructedListWithStartCase;
  if (_topThreeBrands?.length > 1) {
    _topThreeBrands[_topThreeBrands?.length - 1] = `${more}`;
  }
  const colonWithTopThreeBrands = getText(':', _topThreeBrands);

  const formattedTopThreeBrands = getText('', topThreeBrands?.constructedList);
  const newReleasesAndIconicStylesFromTopThreeBrands =
    formattedTopThreeBrands?.length > 0
      ? t(
          `${TP}.newReleasesAndIconicStylesFromTopThreeBrands`,
          'New releases & iconic styles from {formattedTopThreeBrands}.',
          { formattedTopThreeBrands },
        )
      : '';

  const title = t(
    `${TP}.title`,
    'Buy {upperMaterialValueWithStartCase} {topLevelCategoryWithStartCase}{colonWithTopThreeBrands}',
    {
      upperMaterialValueWithStartCase,
      topLevelCategoryWithStartCase,
      colonWithTopThreeBrands,
    },
  );
  const description = t(
    `${TP}.description`,
    'Shop {upperMaterialValue} {topLevelCategory} on GOAT. {newReleasesAndIconicStylesFromTopThreeBrands} Authenticity assured.',
    {
      upperMaterialValue,
      topLevelCategory,
      newReleasesAndIconicStylesFromTopThreeBrands,
    },
  );

  return {
    pageTitle: pageTitle || appendGOATandCountryCodeToTitle(title, locale),
    pageDescription: pageDescription || description,
  };
};
